module.exports = __webpack_public_path__ + "static/media/background_whatsapp.8c989945.jpg";